// extracted by mini-css-extract-plugin
export var details = "_ij-0";
export var inspectorPopover = "_ij-1";